import { render, staticRenderFns } from "./input-button.vue?vue&type=template&id=2c185c2f&"
import script from "./input-button.vue?vue&type=script&lang=js&"
export * from "./input-button.vue?vue&type=script&lang=js&"
import style0 from "./input-button.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "input-button.vue"
export default component.exports